import React from 'react';
import { useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';

const Banner = ({ movies }) => {
    const { genreList } = useSelector(state => state.movie)
    // /console.log("genreList", genreList.genres)
    return (
        <div style={{
            backgroundImage: "url(" + `https://www.themoviedb.org/t/p/w1920_and_h800_multi_faces${movies.poster_path}` + ")"
        }} className='banner'>

            <div className='banner-info'>
                <h2>{movies.title}</h2>
                <p>{movies.overview}</p>

                <div className='movie_add_info'>
                    <div className='origin_title'><span>원제</span> {movies.original_title}</div>
                    <div className='release_date'>
                        <span>개봉일 </span>{movies.release_date}
                    </div>
                    <div className='adult'>
                        {movies.adult === true ? <span>청소년관람불가</span> : <span>청소년관람가</span>}
                    </div>
                    <div className='genre'>
                        {/* 각 장르 ID에 대해 genreList에서 해당하는 장르를 찾음  */}
                        {movies.genre_ids.map((id, idx) => {
                            const genre = genreList.genres.find(genre => genre.id === id);
                            return <span bg="warning" key={idx}>{genre.name}</span>;
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner